import { z } from 'zod';

export const baseCustomFieldSchema = z.object({
  fieldName: z
    .string({ error: 'Nazwa pola jest wymagana' })
    .min(1, 'Nazwa pola jest wymagana')
    .max(100, 'Nazwa pola nie może przekraczać 100 znaków'),
  isFieldMandatory: z.boolean({ error: 'Pole wymagene' }),
  hint: z.string().max(1000, 'Maksymalna długość podpowiedzi to 1000 znaków'),
});

export type BaseCustomFieldInputData = z.input<typeof baseCustomFieldSchema>;
export type BaseCustomFieldFormData = z.infer<typeof baseCustomFieldSchema>;
